// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './NotificationOverlay.module.scss';

const NotificationOverlay = ({ children }) => {
  return (
    <div
      className={classNames('fixed-top', styles.overlay)}
      data-testid="notification-overlay"
    >
      {children}
    </div>
  );
};

NotificationOverlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default NotificationOverlay;
